import React from 'react';
import {
  americanToDecimal,
  decimalToAmerican,
  decimalToFractional,
  fractionalToDecimal,
  parseAmerican,
  parseDecimal,
  parseFractional,
} from './OddUtils';

import { InputContainer } from '../InputContainer/InputContainer';
import styles from './InputOdds.module.scss';
import { Validity } from '../../interfaces/tip/Validations';

export type OddsType = {
  american: string;
  decimal: string;
  fractional: string;
};
interface InputOddsProps {
  label: string;
  placeholder: string;
  onChange: (odds: OddsType) => void;
  value: OddsType;
  oddsFormat: 'AMERICAN' | 'DECIMAL' | 'FRACTIONAL';
  validity: Validity | false;
  disabled?: boolean;
}

export const InputOdds: React.FC<InputOddsProps> = ({
  label,
  placeholder,
  onChange,
  value,
  oddsFormat,
  validity,
  disabled = false,
}) => {
  const handleOnSubmit = (formattedOdds: OddsType) => {
    onChange(formattedOdds);
  };
  const parseOnBlur = (value: any) => {
    let formattedOdds = { ...value };

    //parse decimal odds
    if (formattedOdds.decimal.length) {
      const parsedOdds = parseFloat(formattedOdds.decimal);
      if (!parsedOdds || isNaN(parsedOdds)) {
        formattedOdds = {
          decimal: '',
          american: '',
          fractional: '',
        };
      } else {
        formattedOdds.decimal = parsedOdds.toFixed(2);
      }
    }

    //if american value is less than 100, reset field
    if (oddsFormat === 'AMERICAN' && value.length < 4) {
      formattedOdds = {
        decimal: '',
        american: '',
        fractional: '',
      };
    }
    //if fractional make sure it's complete , if not add /1
    if (oddsFormat === 'FRACTIONAL') {
      if (value.length > 0) {
        if (!value.includes('/')) {
          const newVal = value + '/1';
          const dec = fractionalToDecimal(newVal);
          formattedOdds = {
            decimal: dec.toFixed(2),
            american: decimalToAmerican(dec),
            fractional: newVal,
          };
        } else if (value.endsWith('/')) {
          const newVal = value + '1';
          const dec = fractionalToDecimal(newVal);
          formattedOdds = {
            decimal: dec.toFixed(2),
            american: decimalToAmerican(dec),
            fractional: newVal,
          };
        }
      }
    }

    handleOnSubmit(formattedOdds);
  };
  const parseOnInputChange = (value: string) => {
    if (oddsFormat === 'DECIMAL') {
      const parsedOdds = parseDecimal(value);
      onChange({
        decimal: parsedOdds,
        american: decimalToAmerican(parsedOdds),
        fractional: decimalToFractional(parsedOdds, false),
      });
    }
    if (oddsFormat === 'FRACTIONAL') {
      const parsedOdds = parseFractional(value);
      const decOdds = fractionalToDecimal(parsedOdds);
      onChange({
        decimal: decOdds.toFixed(2),
        american: decimalToAmerican(decOdds),
        fractional: parsedOdds,
      });
    }
    if (oddsFormat === 'AMERICAN') {
      const parsedOdds = parseAmerican(value);
      const decOdds = americanToDecimal(parsedOdds);
      onChange({
        decimal: decOdds.toFixed(2),
        american: parsedOdds,
        fractional: decimalToFractional(decOdds, false),
      });
    }
  };

  return (
    <InputContainer label={label} isDropdown={false} validity={validity}>
      <input
        inputMode={
          oddsFormat === 'DECIMAL'
            ? 'decimal'
            : oddsFormat === 'FRACTIONAL'
            ? 'url'
            : 'text'
        }
        disabled={disabled}
        className={styles.InputOdds}
        type="text"
        //@ts-ignore
        value={value[oddsFormat.toLowerCase()]}
        placeholder={placeholder}
        onChange={(e: any) => parseOnInputChange(e.target.value)}
        onBlur={() => parseOnBlur(value)}
      />
    </InputContainer>
  );
};
